/* KLOTHOS — state model unico del modulo de compra PDP
   E02 · H5 · PDP · EXECUTION-01

   Un solo modelo de estado alimenta: las dos tarjetas, CTA, precio,
   variant id, cantidad y selling_plan. ADDENDUM F5-FINAL: en movil las
   tarjetas se apilan y cada una muestra su propio detalle, de modo que
   el clon externo desaparece. La reentrada ("Elige tu formato") escribe en este
   mismo modelo; no existe un segundo add-to-cart.

   El mecanismo de add-to-cart NO cambia: mismo handler delegado en
   fase de captura, mismo KL_ROOT, misma URL /cart/add. Se reproduce
   verbatim desde product.body_html, de donde procede.

   Sin JS, el <form> sigue posteando a /cart/add con la variante
   Individual: el fallback es la modalidad por defecto.
*/
(function () {
  'use strict';

  var root = document.getElementById('kl-h5-compra');
  if (!root) return;

  var KL_ROOT = root.getAttribute('data-kl-root') || '';

  var group = document.getElementById('kl-h5-radiogroup');
  var inputVariant = document.getElementById('kl-variant-id');
  var inputPlan = document.getElementById('kl-selling-plan');
  var inputQty = document.getElementById('kl-quantity');
  var cta = document.getElementById('kl-btn-compra');

  var cards = group ? Array.prototype.slice.call(group.querySelectorAll('[role="radio"]')) : [];
  if (!cards.length) return;

  function cardFor(modalidad) {
    for (var i = 0; i < cards.length; i++) {
      if (cards[i].getAttribute('data-kl-modalidad') === modalidad) return cards[i];
    }
    return null;
  }

  /* Unico punto de escritura del estado */
  function select(modalidad, opts) {
    var target = cardFor(modalidad);
    if (!target) return;
    opts = opts || {};

    for (var i = 0; i < cards.length; i++) {
      var on = cards[i] === target;
      cards[i].setAttribute('aria-checked', on ? 'true' : 'false');
      cards[i].setAttribute('tabindex', on ? '0' : '-1');
      if (on) cards[i].classList.add('kl-h5-card--activa');
      else cards[i].classList.remove('kl-h5-card--activa');
    }

    if (inputVariant) inputVariant.value = target.getAttribute('data-kl-variant') || '';

    var plan = target.getAttribute('data-kl-selling-plan') || '';
    if (inputPlan) {
      inputPlan.value = plan;
      inputPlan.disabled = !plan;
    }

    /* La cantidad es parte del estado: Individual = 1, suscripcion = 3
       de la MISMA variante. No hay variante de pack. */
    if (inputQty) inputQty.value = target.getAttribute('data-kl-quantity') || '1';

    var ctaText = target.getAttribute('data-kl-cta');
    if (cta && ctaText) cta.textContent = ctaText;

    if (opts.focus) {
      try { target.focus(); } catch (err) { /* noop */ }
    }
  }

  /* Puntero */
  for (var i = 0; i < cards.length; i++) {
    (function (card) {
      card.addEventListener('click', function () {
        select(card.getAttribute('data-kl-modalidad'), { focus: true });
      });
    })(cards[i]);
  }

  /* Teclado: patron radiogroup (flechas mueven y seleccionan) */
  if (group) {
    group.addEventListener('keydown', function (e) {
      var idx = cards.indexOf(document.activeElement);
      if (idx === -1) return;
      var next = null;

      switch (e.key) {
        case 'ArrowRight':
        case 'ArrowDown':
          next = cards[(idx + 1) % cards.length];
          break;
        case 'ArrowLeft':
        case 'ArrowUp':
          next = cards[(idx - 1 + cards.length) % cards.length];
          break;
        case 'Home':
          next = cards[0];
          break;
        case 'End':
          next = cards[cards.length - 1];
          break;
        case ' ':
        case 'Spacebar':
        case 'Enter':
          next = cards[idx];
          break;
        default:
          return;
      }

      e.preventDefault();
      select(next.getAttribute('data-kl-modalidad'), { focus: true });
    });
  }

  /* Reentrada: fija modalidad + lleva el foco al modulo de compra */
  var reentradas = document.querySelectorAll('[data-kl-reentrada]');
  for (var r = 0; r < reentradas.length; r++) {
    (function (btn) {
      btn.addEventListener('click', function () {
        var modalidad = btn.getAttribute('data-kl-reentrada');
        select(modalidad, { focus: false });
        try {
          root.scrollIntoView({ behavior: 'smooth', block: 'start' });
        } catch (err) {
          root.scrollIntoView();
        }
        var target = cardFor(modalidad);
        if (target) {
          window.setTimeout(function () {
            try { target.focus({ preventScroll: true }); } catch (err) { target.focus(); }
          }, 400);
        }
      });
    })(reentradas[r]);
  }

  /* Estado inicial: la modalidad ya marcada en el HTML servido */
  var inicial = 'individual';
  for (var k = 0; k < cards.length; k++) {
    if (cards[k].getAttribute('aria-checked') === 'true') {
      inicial = cards[k].getAttribute('data-kl-modalidad');
      break;
    }
  }
  select(inicial, { focus: false });

  /* ─────────────────────────────────────────────────────────────
     Add-to-cart: mecanismo vigente, reproducido sin cambios.
     Captura para ejecutarse antes que cualquier otro handler.
  ───────────────────────────────────────────────────────────── */
  document.addEventListener('click', function (e) {
    var t = e.target, b = null;
    while (t && t !== document) {
      if (t.id === 'kl-btn-compra') { b = t; break; }
      t = t.parentNode;
    }
    if (!b) return;
    e.preventDefault(); e.stopPropagation(); e.stopImmediatePropagation();
    var v = document.getElementById('kl-variant-id');
    var s = document.getElementById('kl-selling-plan');
    var q = document.getElementById('kl-quantity');
    var u = KL_ROOT + '/cart/add?id=' + ((v && v.value) ? v.value : '52532303855963') + '&quantity=' + ((q && q.value) ? q.value : '1');
    if (s && !s.disabled && s.value) u += '&selling_plan=' + s.value;
    window.location.href = u;
  }, true);

})();
